import AuthGuard from "app/auth/AuthGuard";
import { MatxLayout } from "app/components";
import attendanceRoutes from "app/views/attendance/AttendanceRoutes";
import departmentRoutes from "app/views/configuration/department/DepartmentRoutes";
import designationRoutes from "app/views/configuration/designation/DesignationRoutes";
import zoneRoutes from "app/views/configuration/zone/ZoneRoutes";
import dashboardRoutes from "app/views/dashboard/DashboardRoutes";
import dealerRoutes from "app/views/Dealer/DealerRoutes";
import dealerVisitRoutes from "app/views/DealerVisit/DealerVisitRoutes";
import farmerRoutes from "app/views/Farmer/FarmerRoutes";
import farmTypeRoutes from "app/views/FarmType/FarmTypeRoutes";
import farmVisitRoutes from "app/views/FarmVisit/FarmVisitRoutes";
import feedCompanyRoutes from "app/views/FeedCompany/FeedCompanyRoutes";
import marketingOfficerWiseFarmVisitRoutes from "app/views/MarketingOfficerWiseFarmVisit/MarketingOfficerWiseFarmVisitRoutes";
import roleRoutes from "app/views/Role/roleRoutes";
import NotFound from "app/views/sessions/NotFound";
import sessionRoutes from "app/views/sessions/SessionRoutes";
import userRoutes from "app/views/User/user.route";
import { Navigate } from "react-router-dom";
const routes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      ...dashboardRoutes,
      ...dealerVisitRoutes,
      ...userRoutes,
      ...roleRoutes,
      ...dealerRoutes,
      ...farmerRoutes,
      ...feedCompanyRoutes,
      ...farmTypeRoutes,
      ...farmVisitRoutes,
      ...marketingOfficerWiseFarmVisitRoutes,
      ...attendanceRoutes,
      ...departmentRoutes,
      ...designationRoutes,
      ...zoneRoutes,
    ],
  },
  ...sessionRoutes,
  { path: "/", element: <Navigate to="dashboard/default" /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
